import React from 'react';
import { Link } from 'react-router-dom';
import { generateSlug } from '../utils/slugify';
import { FiCheckCircle } from 'react-icons/fi';
import { getImageUrl } from '../utils/imageUtils';

const BuilderCard = ({ builder }) => {
  return (
    <div 
      className="bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col relative border border-gray-100 mx-auto w-full group"
      style={{ overflow: 'hidden', borderRadius: '16px' }}
    >
      {/* Cover Image or Fallback Grid */}
      <Link 
        to={`/profile/builder/${builder._id}/${generateSlug(builder.name || 'builder')}`} 
        className="w-full block relative aspect-[16/9]" 
      >
        {(builder.banner || builder.coverImage) ? (
          <>
            <img 
              src={getImageUrl(builder.banner || builder.coverImage)} 
              alt="Cover" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
          </>
        ) : (
          <div className="w-full h-full relative" style={{ background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)' }}>
            <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(var(--primary-color, #e85d04) 1px, transparent 1px)', backgroundSize: '10px 10px' }}></div>
          </div>
        )}
      </Link>

      {/* Profile Avatar (Overlapping on left) */}
      <div className="relative" style={{ marginTop: '-32px', padding: '0 20px' }}>
        <Link 
          to={`/profile/builder/${builder._id}/${generateSlug(builder.name || 'builder')}`}
          className="shadow-md"
          style={{ width: '64px', height: '64px', borderRadius: '12px', border: '2px solid white', overflow: 'hidden', position: 'relative', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white' }}
        >
          {(builder.builderLogo || builder.profileImage) ? (
            <img 
              src={getImageUrl(builder.builderLogo || builder.profileImage)} 
              alt={builder.name} 
              className="w-full h-full object-cover" 
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          ) : (
            <div 
              className="font-bold text-white transition-transform duration-500" 
              style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', background: 'linear-gradient(135deg, var(--primary-color) 0%, #e85d04 100%)' }}
            >
              {builder.name?.charAt(0)?.toUpperCase()}
            </div>
          )}
        </Link>
      </div>

      {/* Content */}
      <div className="flex-grow flex flex-col justify-between" style={{ padding: '20px' }}>
        <div className="mb-4">
          <Link 
            to={`/profile/builder/${builder._id}/${generateSlug(builder.name || 'builder')}`}
            className="hover:text-primary transition-colors"
          >
            <h3 className="text-xl font-extrabold text-slate-800 truncate mb-1">
              {builder.name || 'Builder Name'}
            </h3>
            
            {/* Real Project/Property Stats */}
            <div className="flex items-center gap-3 mb-2">
              <p className="text-sm font-semibold text-slate-600 truncate">
                {builder.activeProjectsCount || 0} Active Projects
              </p>
              <span className="text-gray-300">|</span>
              <p className="text-sm font-semibold text-slate-600 truncate">
                {builder.activePropertiesCount || 0} Active Properties
              </p>
            </div>
          </Link>
        </div>
        
        {/* Action Buttons */}
        <div className="mt-auto pt-2">
          <Link 
            to={`/profile/builder/${builder._id}/${generateSlug(builder.name || 'builder')}`}
            className="w-full block py-2.5 rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-bold text-sm transition-colors text-center shadow-sm"
          >
            View Profile
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BuilderCard;
